import { camelCase } from 'shared/lib/lodash/lodash';

export const convertKeysToCamelCase = (
    obj: Record<string, any>,
    keysToNotConvert: string[] = [],
): Record<string, any> => {
    if (typeof obj !== 'object' || !obj) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map((item) =>
            convertKeysToCamelCase(item, keysToNotConvert),
        );
    }

    const newObj: Record<string, any> = {};

    for (const [key, value] of Object.entries(obj)) {
        const newKey = camelCase(key);
        // Preserve the original keys in specified hashes (e.g., `specifications`)
        if (
            keysToNotConvert.includes(newKey) &&
            typeof value === 'object' &&
            value !== null &&
            !Array.isArray(value)
        ) {
            newObj[newKey] = value;
        } else {
            const newValue = convertKeysToCamelCase(value, keysToNotConvert);
            newObj[newKey] = newValue;
        }
    }

    return newObj;
};
